import React, { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { XCircle, ArrowLeft, CreditCard } from 'lucide-react';

export function PaymentCancelledPage() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    // Track cancellation event for analytics if needed
    // Track cancellation event for analytics
  }, [sessionId]);

  return (
    <main className="flex min-h-screen items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 p-4">
      <motion.div
        className="w-full max-w-md"
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <Card className="border-slate-700/50 bg-slate-800/90 backdrop-blur-sm">
          <CardHeader className="text-center">
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.2, type: 'spring', stiffness: 200 }}
              className="mx-auto mb-4 flex size-16 items-center justify-center rounded-full bg-orange-500/10"
            >
              <XCircle className="size-8 text-orange-400" />
            </motion.div>
            <CardTitle className="text-2xl font-bold text-white">Payment Cancelled</CardTitle>
            <CardDescription className="text-slate-300">
              Your checkout session was cancelled.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4 text-center">
            <div className="space-y-2 text-sm text-slate-400">
              <p>No charges have been made to your payment method. You can try again anytime.</p>
              <p>
                If you experienced any issues during checkout, please don't hesitate to contact our
                support team.
              </p>
            </div>

            {sessionId && (
              <div className="rounded-lg bg-slate-700/50 p-3">
                <p className="text-xs text-slate-400">
                  Session ID: <span className="font-mono text-slate-300">{sessionId}</span>
                </p>
              </div>
            )}

            <div className="space-y-3 pt-4">
              <Button
                asChild
                className="w-full bg-gradient-to-r from-primary-600 to-primary-500 hover:from-primary-700 hover:to-primary-600"
              >
                <Link to="/marketing/pricing">
                  <CreditCard className="mr-2 size-4" />
                  Try Again
                </Link>
              </Button>

              <Button
                variant="outline"
                asChild
                className="w-full border-slate-600 text-slate-300 hover:bg-slate-700/50"
              >
                <Link to="/">
                  <ArrowLeft className="mr-2 size-4" />
                  Return to Home
                </Link>
              </Button>

              <Button
                variant="ghost"
                asChild
                className="w-full text-slate-400 hover:bg-slate-700/30 hover:text-slate-300"
              >
                <Link to="/contact">Need Help? Contact Support</Link>
              </Button>
            </div>
          </CardContent>
        </Card>
      </motion.div>
    </main>
  );
}

export default PaymentCancelledPage;
